export const JOB_ITEMS_GRID_CODE = 'service-case-order-job-items';
